/**
 * Utility functions for handling file URLs and paths
 */

/**
 * Ensures the file URL has the correct format with the 'main' segment included
 * @param {string} url - The file URL to correct
 * @returns {string} - The corrected URL
 */
export const getCorrectFileUrl = (url) => {
  if (!url) return '';
  
  // Check if URL already contains '/main/' path segment
  if (url.includes('/main/')) {
    return url;
  }
  
  // URL pattern: https://domain.com/lead-attachments/... 
  // Corrected URL: https://domain.com/main/lead-attachments/...
  const urlParts = url.split('/');
  
  // Find the index of 'lead-attachments' or similar segment
  const segmentIndex = urlParts.findIndex(part => 
    part === 'lead-attachments' || 
    part.includes('attachments') || 
    part === 'proposals' ||
    part === 'proposal' ||
    part === 'projects' ||
    part === 'safety-content' ||
    part === 'profile-pictures'
  );
  
  if (segmentIndex > 0) {
    // Insert 'main' before the segment
    urlParts.splice(segmentIndex, 0, 'main');
    return urlParts.join('/');
  }
  
  return url;
};

/**
 * Determines if a file is an image based on its file name or MIME type
 * @param {string} fileName - The name of the file
 * @param {string} fileType - Optional MIME type of the file
 * @returns {boolean} - Whether the file is an image
 */
export const isImageFile = (fileName, fileType = null) => {
  if (fileType && fileType.startsWith('image/')) {
    return true;
  }
  
  if (fileName) {
    const extension = fileName.split('.').pop().toLowerCase();
    return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(extension);
  }
  
  return false;
};

/**
 * Determines if a file is a PDF based on its file name or MIME type
 * @param {string} fileName - The name of the file
 * @param {string} fileType - Optional MIME type of the file
 * @returns {boolean} - Whether the file is a PDF
 */
export const isPdfFile = (fileName, fileType = null) => {
  if (fileType && fileType === 'application/pdf') {
    return true;
  }
  
  if (fileName) {
    const extension = fileName.split('.').pop().toLowerCase();
    return extension === 'pdf';
  }
  
  return false;
}; 